<mat-stepper
  [linear]="true"
  [orientation]="(stepperOrientation | async)!"
  [selectedIndex]="attribute?.selectedIndex"
  [disableRipple]="attribute?.disableRipple"
  [labelPosition]="attribute?.labelPosition"
  [ngClass]="attribute?.className ? attribute?.className : ''"
  (selectionChange)="selectedStepChange($event, stepData)"
  class="dg-appgen-stepper dg-ag-common"
>
  <ng-container *ngFor="let step of stepData">
    <mat-step
      *ngIf="!step?.attribute?.hideShow"
      [stepControl]="getStepControl | func: commonService.appGenFormGroup:step"
      errorMessage="Please Fill Mandatory Fields"
    >
      <ng-template matStepLabel>
        <p class="parent-main-title">{{ step.lbl }}</p>
        <p class="child-status-title"></p>
      </ng-template>
      <ng-container *ngFor="let data of step.children">
        <ng-container [ngSwitch]="true">
          <app-app-gen-stepper
            *ngSwitchCase="data.fieldType == 97"
            [stepData]="data.children"
            [attribute]="data.attribute"
            [eventId]="eventId"
          >
          </app-app-gen-stepper>
          <app-app-gen-tab
            *ngSwitchCase="data.fieldType == 102"
            [tabData]="data.children"
            [tabObject]="data"
            [attribute]="data.attribute"
            [eventId]="eventId"
          >
          </app-app-gen-tab>
          <app-gen-checklist
            *ngSwitchCase="data.fieldType == 107"
            [checklistData]="data"
            [attribute]="data.attribute"
            [eventId]="eventId"
          ></app-gen-checklist>
          <app-app-gen-card
            *ngSwitchCase="data.fieldType == 89"
            [cardData]="data"
            [eventId]="eventId"
          >
          </app-app-gen-card>
          <app-gen-column
            *ngSwitchCase="data.fieldType == 106"
            [columnData]="data.children"
            [attribute]="data.attribute"
            [eventId]="eventId"
          ></app-gen-column>
          <app-common
            *ngSwitchCase="
              data.fieldType == 51 ||
              data.fieldType == 12 ||
              data.fieldType == 23 ||
              data.fieldType == 25 ||
              data.fieldType == 24 ||
              data.fieldType == 40 ||
              data.fieldType == 71 ||
              data.fieldType == 74 ||
              data.fieldType == 79 ||
              data.fieldType == 81 ||
              data.fieldType == 83 ||
              data.fieldType == 87 ||
              data.fieldType == 90 ||
              data.fieldType == 91 ||
              data.fieldType == 92 ||
              data.fieldType == 99 ||
              data.fieldType == 100 ||
              data.fieldType == 103 ||
              data.fieldType == 104 ||
              data.fieldType == 105 ||
              data.fieldType == 108 ||
              data.fieldType == 111 ||
              data.fieldType == 16
            "
            [res]="data"
            [formId]="FORMID"
            [tid]="tid"
            (emitTransId)="getTransId($event)"
            [ngClass]="data.fieldType == 99 ? 'AppGen-button' : ''"
          >
          </app-common>

          <!-- adHost
              [eventData]="data?.cmnFormFieldEventList"
            
               id="{{ 'a' + data.fieldId }}"
               [hidden]="data.isVisible == 1"
              [ngClass]="data.isVisible == 1 ? 'dis' : ''"
            -->

          <ng-container *ngIf="eventId == 23">
            <ng-container *ngSwitchDefault>
              <dg-dynamic-input
                *ngIf="!data.attribute.hideShow"
                [id]="'comp' + data.attribute.fieldId"
                [data]="data.attribute"
                [value]="data?.defaultValue"
                [showLabel]="showLabel"
                [dataPropConfig]="inputDataPropConfig"
                [comboPropConfig]="comboPropConfig"
                [form]="commonService.appGenFormGroup"
                [ngClass]="
                  data.attribute.className
                    ? data.attribute.className
                    : 'appgen-w-35'
                "
                class="dg-appgen-dynamic-input"
                (onChangeEvent)="onInputChange(data, 'onChange')"
                (onBlurEvent)="onInputChange(data, 'onBlur')"
                (onSearchClick)="onInputChange(data, 'search')"
                (keypress)="onKeyPress($event)"
              >
              </dg-dynamic-input>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="eventId != 23">
            <ng-container *ngSwitchDefault>
              <dg-dynamic-input
                *ngIf="!data.attribute.hideShow"
                [id]="'comp' + data.attribute.fieldId"
                [data]="data.attribute"
                [value]="data?.attribute.defaultValue"
                [showLabel]="showLabel"
                [dataPropConfig]="inputDataPropConfig"
                [comboPropConfig]="comboPropConfig"
                [form]="commonService.appGenFormGroup"
                [ngClass]="
                  data.attribute.className
                    ? data.attribute.className
                    : 'appgen-w-35'
                "
                class="dg-appgen-dynamic-input"
                (onChangeEvent)="onInputChange(data, 'onChange')"
                (onBlurEvent)="onInputChange(data, 'onBlur')"
                (onSearchClick)="onInputChange(data, 'search')"
                (keypress)="onKeyPress($event)"
              >
              </dg-dynamic-input>
            </ng-container>
          </ng-container>
        </ng-container>
      </ng-container>

      <div *ngIf="!tabButton" class="AppGen-button next-previous-btn">
        <button
          *ngIf="attribute.selectedIndex > 0"
          mat-raised-button
          color="primary"
          matStepperPrevious
          class="me-2"
        >
          Previous
        </button>

        <button
          mat-raised-button
          color="primary"
          matStepperNext
          [ngClass]="!commonService.nextTab ? '' : 'd-none'"
        >
          Next
        </button>
      </div>
    </mat-step>
  </ng-container>
</mat-stepper>
